import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Radio, Switch } from "antd";
import { EUserRole, ServiceTemplateField, TRANSLATABLE_SERVICE_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { useTranslation } from "../../../../../../others/i18n.js";
import { getDisableStrategies } from "../../../../../../util/template/merge-strategies.js";
import { getFieldNameTranslated } from "../../../../../../util/template/translation.js";
import { FormFieldVisibilityWrapper } from "../../formFieldVisibilityWrapper.js";
import { TemplateMetaDataExtendsStrategyFormField } from "../../templateMetaDataExtendsStrategyFormField.js";
/**
 * Form field for the is CDN.
 *
 * This field allows users to select if the service is a CDN.
 * When the CDN is enabled, a lot of fields are disabled or hidden because CDNs
 * have special requirements that are different from "normal" services.
 *
 * Exception is if the special treatment of contractual clauses for secure global data processing is also checked.
 *
 * @returns The form field component for is CDN.
 */ function FormFieldServiceTemplateIsCdn({ options, onIsCdnChange }) {
    const { t } = useTranslation();
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: ServiceTemplateField.IsCdn,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_SERVICE_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            label: getFieldNameTranslated(ServiceTemplateField.IsCdn, t),
            extra: t("CDNs cannot be blocked (website would no longer work) and operate servers worldwide, so standard contractual clauses for secure global data processing are the only solution. Accordingly, CDNs must be treated differently from “normal” services in the recommendations."),
            shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier,
            required: true,
            children: ({ getFieldValue })=>{
                const extended = getFieldValue(TemplateMetaDataField.Extends);
                return /*#__PURE__*/ _jsx(TemplateMetaDataExtendsStrategyFormField, {
                    extendsFieldName: ServiceTemplateField.IsCdn,
                    disableStrategies: getDisableStrategies(),
                    onKeepContent: extended && /*#__PURE__*/ _jsx(Switch, {
                        disabled: true,
                        checked: extended[ServiceTemplateField.IsCdn]
                    }),
                    children: /*#__PURE__*/ _jsx(Form.Item, {
                        name: ServiceTemplateField.IsCdn,
                        rules: [
                            {
                                required: true,
                                message: t("Please select if the service is a CDN.")
                            }
                        ],
                        noStyle: true,
                        children: /*#__PURE__*/ _jsx(Radio.Group, {
                            options: options,
                            optionType: "button",
                            buttonStyle: "solid",
                            defaultValue: false,
                            onChange: (event)=>onIsCdnChange?.(event.target.value)
                        })
                    })
                });
            }
        })
    });
}
export { FormFieldServiceTemplateIsCdn };
